var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1501 13C13.1501 13.552 12.6684 14 12.075 14C11.4816 14 11 13.552 11 13V9C11 8.448 11.4816 8 12.075 8C12.6684 8 13.1501 8.448 13.1501 9V13ZM12 18C11.448 18 11 17.552 11 17C11 16.448 11.448 16 12 16C12.552 16 13 16.448 13 17C13 17.552 12.552 18 12 18ZM21.8634 18.5965L12.9396 4.48522C12.53 3.83826 11.47 3.83826 11.0604 4.48522L2.13664 18.5965C1.73888 19.2265 2.25705 20 3.07729 20H20.9227C21.743 20 22.2611 19.2265 21.8634 18.5965Z",
    fill: "#FFB63D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warningOrange.6ab40c54010396903974798f0a83c284.svg";
export { ForwardRef as ReactComponent };